export enum OxioLocaleCode {
  en_US = 'en_US',
  es_MX = 'es_MX',
}
